const baseStyles = {
  container: { gap: 0, pl: 0 },
  innerGrid: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexWrap: 'nowrap',
    gap: { xs: 1.2, sm: 1.5 },
  },
  iconWrapper: { display: 'flex', justifyContent: 'center' },
  text: { whiteSpace: 'normal', wordBreak: 'break-word', lineHeight: 1.3 },
};

export const getBaggageInfoStyles = baggageIsRow => {
  if (baggageIsRow) {
    return {
      container: {
        ...baseStyles.container,
        flexDirection: 'row',
        textAlign: 'left',
        marginTop: '5px',
      },
      innerGrid: {
        ...baseStyles.innerGrid,
        flexDirection: 'row',
        alignItems: 'center',
      },
      iconWrapper: { ...baseStyles.iconWrapper, alignItems: 'center' },
      text: {
        ...baseStyles.text,
        fontWeight: 500,
        mt: '13px',
        maxWidth: { xs: '70%', md: '60%' },
      },
      showTitle: false,
      iconTransform: { xs: 'scale(0.8)', lg: 'scale(0.9)' },
    };
  }

  return {
    container: {
      ...baseStyles.container,
      flexDirection: 'column',
      textAlign: 'center',
    },
    innerGrid: {
      ...baseStyles.innerGrid,
      flexDirection: 'column',
      alignItems: 'center',
    },
    iconWrapper: { ...baseStyles.iconWrapper, alignItems: 'flex-end' },
    text: {
      ...baseStyles.text,
      fontWeight: 500,
      mt: 0,
      maxWidth: '100%',
    },
    showTitle: true,
    iconTransform: { xs: 'scale(0.85)', lg: 'scale(1)' },
  };
};
